import React from 'react';

import { PersonalDetailBox } from 'user/components/PersonalDetailBox';
import { CompanyUsersDetailBox } from 'company/components/CompanyUsersDetailBox';
import { CompanyDetailBox } from 'company/components/CompanyDetailBox';
import { BudgetDetailBox } from 'company/components/BudgetDetailBox';

import { BasePage } from './BasePage';

export const AccountPage = () => (
    <BasePage pageTitle="Account">
        <PersonalDetailBox />
        <CompanyUsersDetailBox />
        <CompanyDetailBox />
        <BudgetDetailBox />
    </BasePage>
);
